import styled from "styled-components";
import {styledByTheme} from "../../../themes/architecture/styled-by-theme";

export const MobileMenuItemContainerDefaultBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  align-content: center;
  margin: 1rem;
  background-color: ${({theme}) => theme.colors.background};
`

export const MobileMenuItemContainerMrGreenBox = styled(MobileMenuItemContainerDefaultBox)`
  background-color:  transparent;
`

export const MobileMenuItemContainerBox = styledByTheme(MobileMenuItemContainerDefaultBox)
    .forMrGreen(MobileMenuItemContainerMrGreenBox)
    .apply();